import gpaGuideData from './gpa-guide-content.json';
import type { GpaGuideContent } from './types';

export * from './types';

export const gpaGuideContent = gpaGuideData as GpaGuideContent;
